import { WebPlugin } from '@capacitor/core';
export class RateAppWeb extends WebPlugin {
    async requestReview() {
        return;
    }
}
//# sourceMappingURL=web.js.map